import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const locationTypePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  synonyms: PropTypes.arrayOf(PropTypes.string),
  position: PropTypes.number.isRequired,
  isExcludedFromSearch: PropTypes.bool,
  isExcludedFromBrowsing: PropTypes.bool,
  node: nodePropType.isRequired,
})

locationTypePropType.defaultProps = {
  description: undefined,
  isExcludedFromSearch: false,
  isExcludedFromBrowsing: false,
}

export default locationTypePropType
